<template>
  <vx-card :title="$t('general.filters')" class="mb-8" collapse-action ref="filterCard">
    <div class="vx-row">
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">{{ $t('class-room.degree') }}</label>
        <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="degrees" @input="onDegreeChange"
                  selectOnTab
                  class="mb-4 md:mb-0"
                  v-model="local.selectedDegree">

          <!--label option-->
          <template #selected-option="{ nameLocal }">
            {{ nameLocal }}
          </template>

          <!--option list-->
          <template v-slot:option="option">
            {{ option.code }} {{ option.nameLocal }}
          </template>
        </v-select>
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">{{ $t('class-room.subject-group') }}</label>
        <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="subjectGroups" @input="onSubjectGroupChange"
                  selectOnTab
                  class="mb-4 md:mb-0"
                  v-model="local.selectedSubjectGroup">

          <!--label option-->
          <template #selected-option="{ nameLocal }">
            {{ nameLocal }}
          </template>

          <!--option list-->
          <template v-slot:option="option">
            {{ option.code }} {{ option.nameLocal }}
          </template>
        </v-select>
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">{{ $t('class-room.subject') }}</label>
        <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="subjects" @input="onSubjectChange"
                  selectOnTab
                  class="mb-4 md:mb-0"
                  v-model="local.selectedSubject">

          <!--label option-->
          <template #selected-option="{ code }">
            {{ code }}
          </template>

          <!--option list-->
          <template v-slot:option="option">
            {{ option.code }} {{ option.nameLocal }}
          </template>
        </v-select>
      </div>
      <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
        <label class="text-sm opacity-75">{{ $t('class-room.teacher') }}</label>
        <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="teachers"
                  selectOnTab
                  @input="onTeacherChange"
                  class="mb-4 sm:mb-0" v-model="local.selectedTeacher">

          <!--label option-->
          <template #selected-option="option">
            {{ option | teacherName }}
          </template>

          <!--option list-->
          <template v-slot:option="option">
            {{ option.code }} {{ option | teacherName }}
          </template>

        </v-select>
      </div>
    </div>
  </vx-card>
</template>

<script>
  import _store from '@/store';
  import vSelect from 'vue-select'
  import Teacher from '@/store/modules/profile/teacher';
  import Degree from '@/store/modules/common-data/degree';
  import SubjectGroup from '@/store/modules/common-data/subject-group';
  import Subject from '@/store/modules/common-data/subject/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";


  if (!_store.state.Teacher) _store.state.registerModule(`Teacher`, Teacher);
  if (!_store.state.Degree) _store.state.registerModule(`Degree`, Degree);
  if (!_store.state.SubjectGroup) _store.state.registerModule(`SubjectGroup`, SubjectGroup);
  if (!_store.state.Subject) _store.state.registerModule(`Subject`, Subject);

  const {
    mapActions: mapTeacherActions,
  } = createNamespacedHelpers(`Teacher`);
  const {
    mapActions: mapSubjectActions,
  } = createNamespacedHelpers(`Subject`);
  const {
    mapActions: mapSubjectGroupActions,
  } = createNamespacedHelpers(`SubjectGroup`);
  const {
    mapActions: mapDegreeActions,
  } = createNamespacedHelpers(`Degree`);


  const {
    mapFields: mapDegreeFields,
  } = createHelpers({
    getterType: `Degree/getField`,
    mutationType: `Degree/updateField`,
  });
  const {
    mapFields: mapSubjectGroupFields,
  } = createHelpers({
    getterType: `SubjectGroup/getField`,
    mutationType: `SubjectGroup/updateField`,
  });
  const {
    mapFields: mapSubjectFields,
  } = createHelpers({
    getterType: `Subject/getField`,
    mutationType: `Subject/updateField`,
  });
  const {
    mapFields: mapTeacherFields,
  } = createHelpers({
    getterType: `Teacher/getField`,
    mutationType: `Teacher/updateField`,
  });

  export default {
    props:{
      parentState: {
        type: Object,
        require: true,
      }
    },
    components: {
      vSelect,
    },
    data() {
      return {
        local: this.parentState.local,
      }
    },
    computed: {
      ...mapDegreeFields({degreeProcessing: 'processing'}),
      ...mapSubjectGroupFields({subjectGroupProcessing: 'processing'}),
      ...mapSubjectFields({subjectProcessing: 'processing'}),
      ...mapTeacherFields({teacherProcessing: 'processing'}),
      degrees() {
        return _store.state.Degree.degrees;
      },
      subjectGroups() {
        let degreeId = this.local.selectedDegree ? this.local.selectedDegree.id : '';
        return _store.state.SubjectGroup.subjectGroups.filter(element =>
          element.degree.id === degreeId
        );
      },
      subjects() {
        return this.local.subjects;
      },
      teachers() {
        return _store.state.Teacher.teachersDdl;
      },
    },
    watch: {
      degreeProcessing(data) {
        this.local.isProcessing = data;
      },
      subjectGroupProcessing(data) {
        this.local.isProcessing = data;
      },
      subjectProcessing(data) {
        this.local.isProcessing = data;
      },
      teacherProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapSubjectActions({
        getSubjectBySubjectGroupID: 'getSubjectBySubjectGroupID',
      }),
      ...mapDegreeActions({
        getDegrees: 'getDegrees',
      }),
      ...mapSubjectGroupActions({
        getSubjectGroups: 'getSubjectGroups',
      }),
      ...mapTeacherActions({
        getTeachersDdl: 'getTeachersDdl',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      async onDegreeChange() {
        this.local.selectedSubjectGroup = null;
        this.local.selectedSubject = null;
        this.local.subjects = [];
        await this.filterDataTable();
      },
      async onSubjectGroupChange() {
        this.local.selectedSubject = null;
        this.local.subjects = [];
        await this.filterSubjectBySubjectGroup();
        await this.filterDataTable();
      },
      async onSubjectChange() {
        await this.filterDataTable();
      },
      async onTeacherChange() {
        await this.filterDataTable();
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async filterDataTable() {
        await this.$emit('load-data');
      },
      async filterSubjectBySubjectGroup() {
        if (this.local.selectedSubjectGroup && this.local.selectedSubjectGroup.id) {
          this.local.subjects = await this.getSubjectBySubjectGroupID({subjectGroupId: this.local.selectedSubjectGroup.id});
        }
      },
      async initData() {
        if ((!_store.state.Degree.degrees || _store.state.Degree.degrees.length === 0)) {
          await this.getDegrees();
        }
        if ((!_store.state.SubjectGroup.subjectGroups || _store.state.SubjectGroup.subjectGroups.length === 0)) {
          await this.getSubjectGroups();
        }
        if ((!_store.state.Teacher.teachers || _store.state.Teacher.teachers.length === 0)) {
          await this.getTeachersDdl();
        }

      },
    },
    async mounted() {
      //call local function init all data
      await this.initData();
    }
  }
</script>

<style scoped>

</style>
